var showCreateRoles = ['creator', 'editor'];
var financeRole = 'finance';
export var hasAccessToCreateApp = function hasAccessToCreateApp(permissions) {
  return permissions.some(function (_ref) {
    var resource = _ref.resource,
        role = _ref.role;
    return resource === 'Channel' && showCreateRoles.includes(role);
  });
};
export var hasAccessToInsightsApp = function hasAccessToInsightsApp(permissions) {
  return permissions.some(function (_ref2) {
    var resource = _ref2.resource;
    return resource === 'Channel';
  });
};
export var hasAccessToFinanceApp = function hasAccessToFinanceApp(roles) {
  return roles.some(function (role) {
    return financeRole === role;
  });
};
export var hasAccessTo = function hasAccessTo(label) {
  var permissions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var roles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  switch (label) {
    case 'Dashboard':
      return true;

    case 'Create':
      return hasAccessToCreateApp(permissions);

    case 'Insights':
      return hasAccessToInsightsApp(permissions);

    case 'Payout Information':
      return hasAccessToFinanceApp(roles);

    default:
      return false;
  }
};
export var generateUrl = function generateUrl(label, href, isAuth0, token, encodedSession) {
  // Always send encodedSession when linking to Payout Information (It needs to save it)
  if (href === '/' || isAuth0 && label !== 'Payout Information') return href;

  switch (label) {
    case 'Dashboard':
      return "".concat(href, "/").concat(encodedSession);

    case 'Create':
    case 'Insights':
      return "".concat(href, "/sign/").concat(encodedSession);

    case 'Payout Information':
      return "".concat(href, "/sign?encoded_session=").concat(encodedSession);

    default:
      return href;
  }
};